const { renderInnerHTML } = window.BAO.Utils

class WishlistListCreate extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['form', 'input', 'submit', 'input-error', 'form-error']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(document, 'click', this.handleClick.bind(this))

    if (this.els.form?.element) {
      this.listeners.add(
        this.els.form.element,
        'submit',
        this.handleFormSubmit.bind(this),
      )
    }

    this.els.input?.elements?.forEach(inputEl => {
      this.listeners.add(
        inputEl,
        'invalid',
        this.handleInputValidity.bind(this),
      )
      this.listeners.add(inputEl, 'keyup', this.handleInputValidity.bind(this))
      this.listeners.add(inputEl, 'blur', this.handleInputValidity.bind(this))
    })
  }

  handleClick (event) {
    if (
      !event.target.closest(
        `[href="${window.theme?.appSettings?.proxyUrl ||
          '/a/wishlist'}/lists/new/"]`,
      )
    ) {
      return
    }
    event.preventDefault()

    this.openModal()
  }

  async handleFormSubmit (event) {
    event.preventDefault()
    this.els.submit.element.disabled = true

    const formData = new FormData(event.target)

    try {
      const response = await window.BAO.wishlist.createList(
        formData,
        window.BAO.wishlist.token,
      )

      if (!response?.success) {
        this.handleFormError()

        return
      }

      await renderInnerHTML(window.location.href, '.wlt-Lists')
      this.pointNewCardAtCreatedUrl(response)
      this.closeModal()
      this.resetInputs()
    } catch (error) {
      this.handleFormError()
    }
  }

  /**
   * The re-rendered grid carries the new card immediately, because that
   * read is the customer's list metafield. The card's href is the bare
   * slug though, and the list page resolves a slug through the
   * eventually-consistent metaobject search index. For the first seconds
   * of a list's life that link 404s (~3.2s measured, #194). The create
   * response's `url` is the same slug plus the ADR-0038 `?created=<id>`
   * fallback, which resolves by id and re-checks the slug, so point the
   * fresh card at it.
   *
   * One hop only: nothing persists the param, so the next render of this
   * page links the bare slug again, which is the list's permanent URL
   * (ADR-0033).
   */
  pointNewCardAtCreatedUrl ({ slug, url } = {}) {
    if (!slug || !url) return

    const linkEl = document.querySelector(
      `.wlt-Lists a[href$="/lists/${slug}"]`,
    )

    if (!linkEl) return

    linkEl.href = url
  }

  handleFormError () {
    this.els?.['form-error']?.element?.setAttribute('aria-hidden', 'false')
  }

  handleInputValidity (event) {
    const inputErrorEl = this.getInputErrorElByName(event.target.name)

    if (!inputErrorEl) return
    event.preventDefault()

    inputErrorEl.setAttribute('aria-hidden', event.target?.validity?.valid)
  }

  resetInputs () {
    this.els.submit.element.disabled = false

    this.els.input?.elements?.forEach(inputEl => {
      inputEl.value = ''
    })
  }

  getInputErrorElByName (name) {
    return this.els?.['input-error']?.elements?.find(
      inputErrorEl => inputErrorEl?.dataset?.inputName === name,
    )
  }

  openModal () {
    this.dispatchEvent(
      new CustomEvent('site-modal:open', {
        bubbles: true,
        detail: { id: 'wishlist-list-create' },
      }),
    )
  }

  closeModal () {
    this.dispatchEvent(
      new CustomEvent('site-modal:close', {
        bubbles: true,
        detail: { id: 'wishlist-list-create' },
      }),
    )
  }
}

if (!window.customElements.get('wishlist-list-create')) {
  window.customElements.define('wishlist-list-create', WishlistListCreate)
}
